import React from "react";
import "../style/css/Error.css";

export type Error403PageProps = {
  /** Numeric or string error code shown to the user (default: 403) */
  code?: string | number;
  /** Main title shown next to the code (default: 'Acceso Denegado') */
  title?: string;
  /** Descriptive message under the title */
  message?: string;
  /** Link to the home page (default: '/') */
  homeHref?: string;
  /** Link to the login page (default: '/login') */
  loginHref?: string;
  /** Link to the support page (default: '/support') */
  supportHref?: string;
  /** Optional click handlers — if provided, the default navigation will be prevented */
  onHomeClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onLoginClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

const Error403Page: React.FC<Error403PageProps> = ({
  code = 403,
  title = "Acceso Denegado",
  message = "No tiene permiso para ver esta página o recurso. Verifique sus credenciales e intente de nuevo. Si cree que debería tener acceso, contacte al administrador.",
  homeHref = "/",
  loginHref = "/login",
  supportHref = "/support",
  onHomeClick,
  onLoginClick,
}) => {
  const handleHomeClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onHomeClick) {
      e.preventDefault();
      onHomeClick(e);
    }
  };

  const handleLoginClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onLoginClick) {
      e.preventDefault();
      onLoginClick(e);
    }
  };

  return (
    <main className="error-page-card" role="main">
      <article
        className="error-card"
        aria-labelledby="error-title"
        aria-describedby="error-desc"
      >
        <div className="error-visual" aria-hidden="true">
          <div className="circle">
            {/* Error icon: circle with exclamation mark */}
            <svg
              width="44"
              height="44"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              role="img"
              aria-label="Ícono de error"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#dc2626"
                strokeWidth="1.6"
                fill="rgba(220,38,38,0.08)"
              />
              <rect x="11" y="7" width="2" height="7" rx="1" fill="#dc2626" />
              <rect x="11" y="16" width="2" height="2" rx="1" fill="#dc2626" />
            </svg>
          </div>
        </div>

        <div className="error-content">
          <div className="title-row">
            <h3 id="error-title">{title}</h3>
            <div className="code" aria-hidden="true">
              {code}
            </div>
          </div>

          <p id="error-desc">{message}</p>

          {/* <div className="hint">
            <span>
              ¿Necesita ayuda?{" "}
              <a className="support-link" href={supportHref}>
                Contactar soporte
              </a>
            </span>
          </div> */}

          <div className="button-group" role="group" aria-label="Acciones">
            <a
              href={homeHref}
              className="btn btn--primary"
              onClick={handleHomeClick}
              title="Volver al inicio"
            >
              Volver al Inicio
            </a>
          </div>
        </div>
      </article>
    </main>
  );
};

export default Error403Page;
